
import { format } from 'date-fns'
import frLocale from 'date-fns/locale/fr'

import { createTheme, PaletteColorOptions } from '@mui/material/styles'

declare module '@mui/material/styles' {
	interface CustomPalette {
		jraBlue: PaletteColorOptions;
	}
	interface Palette extends CustomPalette { }
	interface PaletteOptions extends CustomPalette { }
}

declare module '@mui/material/Button' {
	interface ButtonPropsColorOverrides {
		jraBlue: true;
	}
}

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor: string) => augmentColor({ color: { main: mainColor } })

export const THEME = createTheme({
	palette: {
		jraBlue: createColor('#008EC8'),
	},
	components: {
		MuiButton: {
			defaultProps: {
				disableElevation: true
			}
		}
	}
})

export function formatDate(params: any) {
	return format(new Date((params.value ? params.value : params)), "dd MMMM yyyy HH:mm", { locale: frLocale })
}

export function formatDateDay(params: any) {
	return format(new Date(params.value || params), "dd MMMM yyyy", { locale: frLocale });
  }

  export function formatDateHours(params: any) {
	return format(new Date(params.value || params), "HH:mm", { locale: frLocale });
  }